import * as NavigationConstants from '../../action/navigation/NavigationConstants';

const initialState = {
  currentKey: ''
};

export const navigationStore = (state = initialState, action) => {
  switch (action.type) {
    case NavigationConstants.SET_NAVIGATION_KEY:
      return {
        ...state,
        currentKey: action.key
      };
    default:
      return state;
  }
};
